'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var cid = require('multiformats/cid');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function normaliseInput(_x) {
  return _normaliseInput.apply(this, arguments);
}

function _normaliseInput() {
  _normaliseInput = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var cid$1, iterator, first, _iterator3, _step3, _cid, _iterator4, _step4, obj, _iterator5, _first, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid2, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _obj;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode__default["default"](new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            cid$1 = cid.CID.asCID(input);

            if (!cid$1) {
              _context.next = 7;
              break;
            }

            _context.next = 6;
            return toPin({
              cid: cid$1
            });

          case 6:
            return _context.abrupt("return");

          case 7:
            if (!(input instanceof String || typeof input === 'string')) {
              _context.next = 11;
              break;
            }

            _context.next = 10;
            return toPin({
              path: input
            });

          case 10:
            return _context.abrupt("return");

          case 11:
            if (!(input.cid != null || input.path != null)) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return toPin(input);

          case 14:
            return _context.abrupt("return", _context.sent);

          case 15:
            if (!(Symbol.iterator in input)) {
              _context.next = 63;
              break;
            }

            iterator = input[Symbol.iterator]();
            first = iterator.next();

            if (!first.done) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return", iterator);

          case 20:
            if (!(cid.CID.asCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
              _context.next = 41;
              break;
            }

            _context.next = 23;
            return toPin({
              cid: first.value
            });

          case 23:
            _iterator3 = _createForOfIteratorHelper(iterator);
            _context.prev = 24;

            _iterator3.s();

          case 26:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 32;
              break;
            }

            _cid = _step3.value;
            _context.next = 30;
            return toPin({
              cid: _cid
            });

          case 30:
            _context.next = 26;
            break;

          case 32:
            _context.next = 37;
            break;

          case 34:
            _context.prev = 34;
            _context.t0 = _context["catch"](24);

            _iterator3.e(_context.t0);

          case 37:
            _context.prev = 37;

            _iterator3.f();

            return _context.finish(37);

          case 40:
            return _context.abrupt("return");

          case 41:
            if (!(first.value.cid != null || first.value.path != null)) {
              _context.next = 62;
              break;
            }

            _context.next = 44;
            return toPin(first.value);

          case 44:
            _iterator4 = _createForOfIteratorHelper(iterator);
            _context.prev = 45;

            _iterator4.s();

          case 47:
            if ((_step4 = _iterator4.n()).done) {
              _context.next = 53;
              break;
            }

            obj = _step4.value;
            _context.next = 51;
            return toPin(obj);

          case 51:
            _context.next = 47;
            break;

          case 53:
            _context.next = 58;
            break;

          case 55:
            _context.prev = 55;
            _context.t1 = _context["catch"](45);

            _iterator4.e(_context.t1);

          case 58:
            _context.prev = 58;

            _iterator4.f();

            return _context.finish(58);

          case 61:
            return _context.abrupt("return");

          case 62:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 63:
            if (!(Symbol.asyncIterator in input)) {
              _context.next = 137;
              break;
            }

            _iterator5 = input[Symbol.asyncIterator]();
            _context.next = 67;
            return _awaitAsyncGenerator(_iterator5.next());

          case 67:
            _first = _context.sent;

            if (!_first.done) {
              _context.next = 70;
              break;
            }

            return _context.abrupt("return", _iterator5);

          case 70:
            if (!(cid.CID.asCID(_first.value) || _first.value instanceof String || typeof _first.value === 'string')) {
              _context.next = 103;
              break;
            }

            _context.next = 73;
            return toPin({
              cid: _first.value
            });

          case 73:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 75;
            _iterator = _asyncIterator(_iterator5);

          case 77:
            _context.next = 79;
            return _awaitAsyncGenerator(_iterator.next());

          case 79:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 86;
              break;
            }

            _cid2 = _step.value;
            _context.next = 83;
            return toPin({
              cid: _cid2
            });

          case 83:
            _iteratorAbruptCompletion = false;
            _context.next = 77;
            break;

          case 86:
            _context.next = 92;
            break;

          case 88:
            _context.prev = 88;
            _context.t2 = _context["catch"](75);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 92:
            _context.prev = 92;
            _context.prev = 93;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 97;
              break;
            }

            _context.next = 97;
            return _awaitAsyncGenerator(_iterator.return());

          case 97:
            _context.prev = 97;

            if (!_didIteratorError) {
              _context.next = 100;
              break;
            }

            throw _iteratorError;

          case 100:
            return _context.finish(97);

          case 101:
            return _context.finish(92);

          case 102:
            return _context.abrupt("return");

          case 103:
            if (!(_first.value.cid != null || _first.value.path != null)) {
              _context.next = 136;
              break;
            }

            _context.next = 106;
            return toPin(_first.value);

          case 106:
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context.prev = 108;
            _iterator2 = _asyncIterator(_iterator5);

          case 110:
            _context.next = 112;
            return _awaitAsyncGenerator(_iterator2.next());

          case 112:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
              _context.next = 119;
              break;
            }

            _obj = _step2.value;
            _context.next = 116;
            return toPin(_obj);

          case 116:
            _iteratorAbruptCompletion2 = false;
            _context.next = 110;
            break;

          case 119:
            _context.next = 125;
            break;

          case 121:
            _context.prev = 121;
            _context.t3 = _context["catch"](108);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t3;

          case 125:
            _context.prev = 125;
            _context.prev = 126;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context.next = 130;
              break;
            }

            _context.next = 130;
            return _awaitAsyncGenerator(_iterator2.return());

          case 130:
            _context.prev = 130;

            if (!_didIteratorError2) {
              _context.next = 133;
              break;
            }

            throw _iteratorError2;

          case 133:
            return _context.finish(130);

          case 134:
            return _context.finish(125);

          case 135:
            return _context.abrupt("return");

          case 136:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 137:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 138:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[24, 34, 37, 40], [45, 55, 58, 61], [75, 88, 92, 102], [93,, 97, 101], [108, 121, 125, 135], [126,, 130, 134]]);
  }));
  return _normaliseInput.apply(this, arguments);
}

function toPin(input) {
  var path = input.cid || "".concat(input.path);

  if (!path) {
    throw errCode__default["default"](new Error('Unexpected input: Please path either a CID or an IPFS path'), 'ERR_UNEXPECTED_INPUT');
  }

  var pin = {
    path: path,
    recursive: input.recursive !== false
  };

  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }

  return pin;
}

exports.normaliseInput = normaliseInput;